"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToCssModules = void 0;
exports.mapToCssModules = (cssModule = []) => {
    if (!cssModule)
        return cssModule;
    return cssModule
        .filter((className) => !!className)
        .join(' ');
};
//# sourceMappingURL=className.js.map